import { render } from "./UpgradePlan.vue?vue&type=template&id=b52a4d1e"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"

import "./UpgradePlan.vue?vue&type=style&index=0&id=b52a4d1e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__